var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHairM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 178,
    viewBox: "0 0 186 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.2 21.8226C115.085 17.6234 115.019 13.3538 115.004 9.01671C115 7.91214 115.937 6.99994 117.042 7.00001C178.73 7.00401 178.999 8.03082 179 163.945C179 165.049 178.094 166.006 176.991 165.946C163.232 165.197 151.407 156.734 141.885 141.897C143.834 138.749 145.547 135.337 147.024 131.679C148.123 131.89 149.257 132 150.415 132C160.586 132 164 123.493 164 113C164 103.83 161.393 96.1774 153.948 94.3929C153.983 93.0451 154 91.6827 154 90.3062C154 52.9766 141.155 29.5466 115.2 21.8226Z",
    className: "Hair"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7917 22.1327C71.912 17.8336 71.9805 13.4606 71.9964 9.01671C72.0004 7.91214 71.0629 6.99994 69.9583 7.00001C8.26987 7.00401 8.00117 8.03082 8.00001 163.945C8 165.049 8.90601 166.006 10.0089 165.946C24.0146 165.183 36.0167 156.428 45.6256 141.092C43.8782 138.17 42.3284 135.027 40.9759 131.679C39.8768 131.89 38.7433 132 37.5849 132C27.4145 132 24 123.493 24 113C24 103.83 26.6075 96.1774 34.0524 94.3929C34.0175 93.0451 34 91.6827 34 90.3062C34 53.4633 46.5126 30.16 71.7917 22.1327Z",
    className: "Hair"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4221 140.749C33.4659 150.294 26.645 162.166 26.0438 175.99C25.9958 177.094 26.9487 178 28.0532 178C44.4189 178 58.641 177.994 71.0003 177.842V162.975C60.0225 158.679 51.5036 151.069 45.4221 140.749ZM116 175.58C147.462 171.533 152.172 160.718 152.877 131.818C152.104 131.938 151.284 132 150.415 132C149.257 132 148.123 131.89 147.024 131.679C140.833 147.01 130.507 158.015 116 163.354V175.58Z",
    className: "HairDark"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125.987 68.9889C71.4606 68.3856 35.1689 43.2233 34.0277 2.01168C33.9971 0.907531 34.9445 -1.68084e-05 36.049 2.67157e-05C127.467 0.0036289 127.999 0.492929 128 66.9567C128 68.0613 127.091 69.0011 125.987 68.9889Z",
    className: "Hair"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M185.991 96.9871C185.547 45.1727 167.914 10.5772 139.006 9.05253C137.903 8.99435 137 9.94379 137 11.0484C137.003 98.1275 137.363 98.9929 183.965 98.9999C185.07 99.0001 186.001 98.0916 185.991 96.9871Z",
    className: "Hair"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M164.973 58.9931C164.133 28.2601 143.93 7.82097 111.009 7.02417C109.905 6.99744 109 7.93335 109 9.03791C109.009 60.5747 109.693 60.9974 162.961 61C164.066 61 165.003 60.0973 164.973 58.9931Z",
    className: "Hair"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9916 11.0138C59.5041 69.5416 37.7217 108.554 2.0094 109.961C0.905683 110.004 -1.17929e-05 109.054 1.86382e-05 107.95C0.00272481 9.72323 0.397718 9.00355 57.9597 9.00002C59.0643 8.99995 60.0008 9.90929 59.9916 11.0138Z",
    className: "Hair"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHairM);
export default __webpack_public_path__ + "static/media/Hair M.fe8de8892cae25d25665f62732bb6351.svg";
export { ForwardRef as ReactComponent };